import { DataTypeConfig } from "../../../../types";

export const paymentsConfig: DataTypeConfig = {
  tabs: [
    "paymentPayType",
    "paymentMode",
    "paymentChannel",
    "paymentType",
    "paymentSubtype",
    "status",
  ],
  searchableColumns: [
    "consumer_no",
    "amount",
    "payment_pay_type",
    "payment_mode",
    "payment_channel",
    "payment_type",
    "payment_subtype",
    "status",
  ],
  filterColumns: [
    { column: "payment_pay_type", type: "dropdown", label: "Payment Pay Type" },
    { column: "payment_mode", type: "dropdown", label: "Payment Mode" },
    { column: "payment_channel", type: "dropdown", label: "Payment Channel" },
    { column: "payment_type", type: "dropdown", label: "Payment Type" },
    { column: "payment_subtype", type: "dropdown", label: "Payment Subtype" },
    { column: "status", type: "dropdown", label: "Status" },
    { column: "payment_date", type: "date", label: "Payment Date" },
    { column: "amount", type: "range", label: "Amount" },
  ],
  tableColumns: [
    { key: "consumer_no", header: "Consumer No", type: "custom" },
    { key: "amount", header: "Amount", type: "custom" },
    { key: "payment_date", header: "Payment Date", type: "custom" },
    { key: "paymentPayType", header: "Pay Type", type: "badge" },
    { key: "paymentMode", header: "Mode", type: "badge" },
    { key: "paymentChannel", header: "Channel", type: "badge" },
    { key: "paymentType", header: "Type", type: "badge" },
    { key: "paymentSubtype", header: "Subtype", type: "badge" },
    { key: "status", header: "Status", type: "badge" },
  ],
  mandatoryFields: [
    "consumer_no",
    "amount",
    "payment_pay_type",
    "payment_mode",
    "payment_channel",
    "payment_type",
    "payment_subtype",
    "payment_date",
    "status",
  ],
};

export const paymentsTabDisplayNames: Record<string, string> = {
  paymentPayType: "Payment Pay Type",
  paymentMode: "Payment Mode",
  paymentChannel: "Payment Channel",
  paymentType: "Payment Type",
  paymentSubtype: "Payment Subtype",
  status: "Status",
};

export const paymentsTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "paymentPayType":
      return [
        { value: "full_payment", label: "Full Payment" },
        { value: "partial_payment", label: "Partial Payment" },
        { value: "advance", label: "Advance" },
      ];
    case "paymentMode":
      return [
        { value: "cash", label: "Cash" },
        { value: "credit_card", label: "Credit Card" },
        { value: "debit_card", label: "Debit Card" },
        { value: "upi", label: "UPI" },
      ];
    case "paymentChannel":
      return [
        { value: "online", label: "Online" },
        { value: "offline", label: "Offline" },
        { value: "mobile_app", label: "Mobile App" },
        { value: "branch", label: "Branch" },
      ];
    case "paymentType":
      return [
        { value: "bill_payment", label: "Bill Payment" },
        { value: "deposit", label: "Deposit" },
        { value: "refund", label: "Refund" },
      ];
    case "paymentSubtype":
      return [
        { value: "regular", label: "Regular" },
        { value: "late_payment", label: "Late Payment" },
        { value: "early_payment", label: "Early Payment" },
      ];
    case "status":
      return [
        { value: "success", label: "Success" },
        { value: "pending", label: "Pending" },
        { value: "failed", label: "Failed" },
        { value: "cancelled", label: "Cancelled" },
      ];
    default:
      return [];
  }
};
